import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María José Fernández',
    city: 'Rosario, Santa Fe',
    text: 'Antes pasaba mis domingos armando las clases de la semana. Desde que compré la guía, llego a la cancha con todo resuelto. Los juegos de entrada en calor son un éxito total con las nenas de 8 años.',
    avatar: 'https://i.pravatar.cc/150?img=47'
  }, {
    name: 'Lucía Gómez',
    city: 'Mar del Plata, Bs As',
    text: 'Excelente material. Lo que más me sirvió fue la progresión de los ejercicios técnicos. Está todo muy bien explicado y es súper fácil de llevar a la práctica. Me salvó la vida.',
    avatar: 'https://i.pravatar.cc/150?img=5'
  }, {
    name: 'Carolina Pérez',
    city: 'Córdoba Capital',
    text: 'Doy clases a tres categorías diferentes y me estaba volviendo loca con las planificaciones. Esta guía me ordenó la cabeza. Vale cada peso, la recuperás en tiempo libre la primera semana.',
    avatar: 'https://i.pravatar.cc/150?img=9'
  }, {
    name: 'Verónica Sosa',
    city: 'La Plata, Bs As',
    text: 'Las dinámicas para mantener la atención de los más chiquitos son oro puro. Ya no reniego para que me escuchen, los ejercicios son tan divertidos que se enganchan solos.',
    avatar: 'https://i.pravatar.cc/150?img=32'
  }, {
    name: 'Andrea Martínez',
    city: 'Mendoza',
    text: 'Soy profe nueva y estaba muy insegura sobre cómo estructurar el año. El esquema mensual me dio una tranquilidad enorme. Lo recomiendo 100% a cualquier profe que recién arranca o que ya está cansada de improvisar.',
    avatar: 'https://i.pravatar.cc/150?img=44'
  }];
  return <section className="py-14 px-4 bg-brand-dark" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <div className="text-center mb-10" data-id="element-177">
          <h2 className="text-4xl md:text-5xl font-display text-brand-cream mb-4 uppercase" data-id="element-178">
            Profes que ya{' '}
            <span className="accent-underline" data-id="element-179">transformaron</span> sus clases
          </h2>
          <p className="text-brand-cream/80 text-lg" data-id="element-180">
            Más de 500 profesores en Argentina ya usan nuestro sistema.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-brand-card p-8 rounded-2xl border border-brand-mint/10 relative ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-182">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-mint/20" data-id="element-183" />
              <div className="flex gap-1 mb-4" data-id="element-184">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-accent text-brand-accent" data-id="element-185" />)}
              </div>
              <p className="text-brand-cream/90 italic mb-6 relative z-10" data-id="element-186">
                "{testimonial.text}"
              </p>
              <div className="mt-auto pt-2 border-t border-brand-mint/10" data-id="element-187">
                <h4 className="font-bold text-brand-cream" data-id="element-188">
                  {testimonial.name}
                </h4>
                <p className="text-xs text-brand-mint mt-1" data-id="element-189">
                  {testimonial.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}